import React from "react";

/**
 * This function behaves exactly like React.useEffect, only it WILL NOT RUN THE
 * CALLBACK ON THE FIRST RENDER. This is useful for fetching data when form state
 * changes, but _only_ when form state changes.
 */
export const useEffectAfterFirstRender: typeof React.useEffect = (
  callback,
  dependencyList
) => {
  const isFirstRenderRef = React.useRef(true);

  React.useEffect(() => {
    if (isFirstRenderRef.current === false) {
      return callback();
    }
    isFirstRenderRef.current = false;
  }, dependencyList);
};
